module.exports = __webpack_public_path__ + "static/img/23-accounting.dea0c86.png";


//////////////////
// WEBPACK FOOTER
// ./static/Icon/23-accounting.png
// module id = feuz
// module chunks = 1